/* avren new range theme JS. Every block is wrapped so one failure never kills the rest. */
(function(){
  function safe(fn){try{fn()}catch(e){if(window.console)console.warn('nr:',e)}}

  /* reveal on scroll, with fail-safes so nothing stays invisible */
  safe(function(){
    var els=[].slice.call(document.querySelectorAll('.rv'));
    function show(el){el.classList.add('in')}
    function inView(){els.forEach(function(el){var r=el.getBoundingClientRect();if(r.top<innerHeight*0.95&&r.bottom>0)show(el)})}
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){show(e.target);io.unobserve(e.target)}})},{rootMargin:'0px 0px -5% 0px'});
      els.forEach(function(el){io.observe(el)});
    }
    inView();addEventListener('scroll',inView,{passive:true});
    setTimeout(inView,400);setTimeout(inView,1200);
    setTimeout(function(){els.forEach(show)},6000);
  });

  /* bag count */
  function setCount(n){document.querySelectorAll('[data-bag-count]').forEach(function(el){el.textContent=n})}
  function syncCart(){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(c){setCount(c.item_count);return c})}
  safe(function(){setTimeout(syncCart,700)});

  /* toast */
  function toast(msg){
    var t=document.querySelector('.toast');
    if(!t){t=document.createElement('div');t.className='toast';t.setAttribute('role','status');document.body.appendChild(t)}
    t.innerHTML=msg+' <a href="/cart">View bag</a>';
    t.classList.add('on');clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('on')},4200);
  }

  /* add to bag: ajax, falls back to a normal form post if anything fails */
  safe(function(){
    document.addEventListener('submit',function(ev){
      var f=ev.target;if(!f.matches||!f.matches('form[data-nr-add]'))return;
      ev.preventDefault();ev.stopImmediatePropagation();
      var btns=document.querySelectorAll('[data-add-btn]');btns.forEach(function(b){b.disabled=true});
      fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:new FormData(f)})
        .then(function(r){if(!r.ok)throw new Error('add failed');return r.json()})
        .then(function(item){toast('Added: '+item.product_title+(item.variant_title?' ('+item.variant_title+')':''));return syncCart()})
        .catch(function(){f.removeAttribute('data-nr-add');f.submit()})
        .then(function(){btns.forEach(function(b){b.disabled=false})});
    },true);
  });

  /* size picker: label shows the chosen size, sticky bar mirrors the main button */
  safe(function(){
    var form=document.querySelector('form[data-nr-add]');if(!form)return;
    var out=document.querySelector('[data-size-out]');
    form.addEventListener('change',function(e){if(e.target.name==='id'&&out)out.textContent=e.target.getAttribute('data-size')});
    var sticky=document.querySelector('.sticky-buy'),main=document.querySelector('.buy .add');
    if(sticky&&main&&'IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(e){sticky.classList.toggle('on',!e.isIntersecting&&e.boundingClientRect.top<0)})}).observe(main);
    }
  });

  /* product gallery thumbs */
  safe(function(){
    document.querySelectorAll('[data-thumb]').forEach(function(b){
      b.addEventListener('click',function(){
        var img=document.querySelector('[data-main-img]');if(!img)return;
        img.src=b.getAttribute('data-thumb');img.removeAttribute('srcset');
        document.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.toggle('on',x===b)});
      });
    });
  });

  /* links to a closed accordion (Size chart) open it and scroll */
  safe(function(){
    document.querySelectorAll('a[href^="#acc-"]').forEach(function(a){
      a.addEventListener('click',function(e){var d=document.querySelector(a.getAttribute('href'));if(!d)return;e.preventDefault();d.open=true;d.scrollIntoView({behavior:'smooth',block:'start'})});
    });
  });

  /* carousels: arrows wrap around at the ends, progress bar follows the scroll */
  safe(function(){
    document.querySelectorAll('.car').forEach(function(c){
      var rail=c.querySelector('.rail'),bar=c.querySelector('.bar i');if(!rail)return;
      function step(){var f=rail.firstElementChild;return f?f.getBoundingClientRect().width+10:300}
      function upd(){if(!bar)return;var max=rail.scrollWidth-rail.clientWidth;var w=Math.max(12,rail.clientWidth/rail.scrollWidth*100);bar.style.width=w+'%';bar.style.left=(max>0?rail.scrollLeft/max*(100-w):0)+'%'}
      c.querySelectorAll('[data-dir]').forEach(function(b){b.addEventListener('click',function(){
        var d=+b.getAttribute('data-dir'),max=rail.scrollWidth-rail.clientWidth-4;
        if(d>0&&rail.scrollLeft>=max)rail.scrollTo({left:0});else if(d<0&&rail.scrollLeft<=4)rail.scrollTo({left:max+4});else rail.scrollBy({left:d*step()});
      })});
      rail.addEventListener('scroll',upd,{passive:true});addEventListener('resize',upd);upd();
    });
  });

  /* size chart pop-up: built from the product's size chart field, cm or inches, chosen size highlighted */
  safe(function(){
    var dlg=document.getElementById('nr-size');if(!dlg)return;
    var src=document.getElementById('nr-size-data');var raw=src?src.textContent:'';
    var rows=[],notes=[];
    raw.split(/\r?\n/).forEach(function(l){l=l.trim();if(!l)return;
      var m=l.match(/^([A-Za-z0-9 ]{1,6}):\s*(.+\|.+|.*\d.*)$/);
      if(m){var cells=m[2].split('|').map(function(c){c=c.trim();var v=c.match(/([\d.]+(?:\s*to\s*[\d.]+)?)\s*cm\s*$/i);return {label:v?c.slice(0,v.index).trim():c,value:v?v[1]:''}});rows.push({size:m[1].trim(),cells:cells})}
      else notes.push(l)});
    var wrap=dlg.querySelector('[data-size-table]'),noteBox=dlg.querySelector('[data-size-notes]'),unit='cm';
    function fmt(v){if(unit==='cm')return v;return v.replace(/[\d.]+/g,function(n){return (parseFloat(n)/2.54).toFixed(1)})}
    function render(){
      if(!rows.length){wrap.innerHTML='<p class="notes">'+(raw||'Size chart coming soon.').replace(/\n/g,'<br>')+'</p>';return}
      var pick=(document.querySelector('[data-size-out]')||{}).textContent;
      var hr=rows.filter(function(r){return r.cells.every(function(c){return c.value})})[0]||rows[0];
      var h='<table><thead><tr><th>Size</th>'+hr.cells.map(function(c){return '<th>'+c.label+'</th>'}).join('')+'</tr></thead><tbody>';
      rows.forEach(function(r){h+='<tr class="'+(r.size===pick?'pick':'')+'"><td>'+r.size+'</td>'+r.cells.map(function(c){return '<td>'+(c.value?fmt(c.value):'<small>ask us</small>')+'</td>'}).join('')+'</tr>'});
      wrap.innerHTML=h+'</tbody></table>';
      if(noteBox)noteBox.innerHTML=notes.map(function(n){return '<p>'+n+'</p>'}).join('')+'<p>All measurements in '+(unit==='cm'?'centimetres':'inches')+'.</p>';
    }
    dlg.querySelectorAll('[data-unit]').forEach(function(b){b.addEventListener('click',function(){unit=b.getAttribute('data-unit');dlg.querySelectorAll('[data-unit]').forEach(function(x){x.classList.toggle('on',x===b)});render()})});
    document.querySelectorAll('[data-size-open]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();render();if(dlg.showModal)dlg.showModal();else dlg.setAttribute('open','')})});
    dlg.querySelectorAll('[data-size-close]').forEach(function(b){b.addEventListener('click',function(){dlg.close?dlg.close():dlg.removeAttribute('open')})});
    dlg.addEventListener('click',function(e){if(e.target===dlg)dlg.close()});
    render();
  });

  /* prices written in pounds (data-gbp) shown in the visitor's currency.
     Whole-number thresholds (free delivery over 80) stay the SAME number in local currency, because that is how
     Shopify Markets fires them (SolarStyle proved it 6 Oct: EUR 82.90 shipped free). Fees like 3.99 convert at the rate. */
  safe(function(){
    var cur=(window.Shopify&&window.Shopify.currency)||{},code=cur.active||'GBP',rate=parseFloat(cur.rate)||1;
    function fmt(v,whole){var o={style:'currency',currency:code};if(whole){o.minimumFractionDigits=0;o.maximumFractionDigits=0}return new Intl.NumberFormat('en-GB',o).format(v)}
    function conv(g){return code==='GBP'||g%1===0?g:g*rate}
    if(code!=='GBP')document.querySelectorAll('[data-gbp]').forEach(function(el){var g=parseFloat(el.getAttribute('data-gbp'));el.textContent=fmt(conv(g),g%1===0)});
    var left=document.querySelector('[data-free-left]');
    if(left){var tot=parseInt(left.getAttribute('data-total'),10)/100,th=conv(80),gap=th-tot;
      left.textContent=gap>0?'Add '+fmt(gap,false)+' more for free delivery':'Free delivery on this order';}
  });

  /* close sort dropdown and mobile menu on outside tap / escape */
  safe(function(){
    document.addEventListener('click',function(e){document.querySelectorAll('details[data-close-out][open]').forEach(function(d){if(!d.contains(e.target))d.open=false})});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')document.querySelectorAll('details[open][data-close-out],.nr-menu[open]').forEach(function(d){d.open=false})});
  });
})();
